import CompanyBalance from "./CompanyBalance.js";
import Model from "../Model.js";

/**
 * `CompanyTransitionBalance` expresses the difference between an
 * opening `companyBalance` and a closing `companyBalance`.
 *
 * Note: This class only exists because we don't trust JavaScript
 * to do subtractions correctly.
 *
 * @param {number[]} spec.openingBalance - .
 * @param {number[]} spec.closingBalance -
 * @param {number[]} spec.totalLiabilityChange -
 * @param {number[]} spec.totalAssetsChange -
 * @param {number[]} spec.ownersPartChange -
 */
export default class CompanyTransitionBalance extends Model {
	constructor(spec) {
		super(spec);

		this.openingBalance = spec.openingBalance;
		this.closingBalance = spec.closingBalance;

		this.totalLiabilityChange = spec.totalLiabilityChange;
		this.totalAssetsChange = spec.totalAssetsChange;
		this.ownersPartChange = spec.ownersPartChange;
	}

	static transformMaterializationData(data) {
		data.openingBalance = CompanyBalance.materialize(data.openingBalance);
		data.closingBalance = CompanyBalance.materialize(data.closingBalance);
	}
}
